import isDevelopment from "./isDevelopment";

const categoryId = isDevelopment ? 3 : 4;

export default categoryId;
